import { Paragraph } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { IconPumpScore } from "../../../../icons";

interface IEffectivityPointsDescription {
  valueGoodChoice: string;
  valueApproved: string;
}
const EffectivityPointsDescription = ({
  valueGoodChoice,
  valueApproved,
}: IEffectivityPointsDescription) => {
  return (
    <>
      <Flex sx={{ marginBottom: "lg" }}>
        <IconPumpScore green value={valueGoodChoice} />
        <Paragraph>Bra val</Paragraph>
      </Flex>
      <Flex>
        <IconPumpScore value={valueApproved} />
        <Paragraph>Godkänt</Paragraph>
      </Flex>
    </>
  );
};

export default EffectivityPointsDescription;
